import React from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import { Breadcrumb, Menu } from "antd";
import { HomeOutlined } from "@ant-design/icons";

import { urls } from "../../../utils";
import { TabelaEncaminhamentos } from "../components/TabelaEncaminhamentos";
import { BotaoAcao } from "../components/Botao/BotaoAcao";

export const EncaminhamentosEnviados = () => {
  const menuBreadcrump = (
    <Menu>
      <Menu.Item>
        <Link to={urls.ENCAMINHAMENTOS_RECEBIDOS}>recebidos</Link>
      </Menu.Item>
    </Menu>
  );

  return (
    <div id="sectionMain">
      <Breadcrumb id="breadcrumb">
        <Breadcrumb.Item key="home">
          <Link to="">
            <HomeOutlined />
          </Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item key="registros">registros</Breadcrumb.Item>
        <Breadcrumb.Item key="denuncias">encaminhamentos</Breadcrumb.Item>
        <Breadcrumb.Item key="denuncias" overlay={menuBreadcrump}>
          <strong>enviados</strong>
        </Breadcrumb.Item>
      </Breadcrumb>

      <div>
        <div className="container-section">
          <div id="header-container">
            <div>
              <h2>LISTA DE ENCAMINHAMENTOS ENVIADOS</h2>
              <span>
                atualizado às {moment().format("HH:mm")} do dia{" "}
                {moment().format("DD/MM/YYYY")}
              </span>
            </div>

            <div id="header-actions">
              <BotaoAcao />
            </div>
          </div>

          <TabelaEncaminhamentos onView enviados />
        </div>
      </div>
    </div>
  );
};
